import TableGrid, { Body, Cell, Head, Row } from './TableGrid';
export { Body, Cell, Head, Row };
export default TableGrid;
